import { AuthenticationResult, RedirectRequest, SilentRequest } from "@azure/msal-browser";
import { ApiClient } from "@dining/api-client";
import { appInsights } from "../components/AppInsights/AppInsights";
import config from "../config";
import msal, { scopes } from "./msal";

const diningClient = new ApiClient(config.apiUri, {
  fetch: async (url: RequestInfo, init?: RequestInit) => {
    let authResult: AuthenticationResult | null = null;

    try {
      const silentRequest: SilentRequest = {
        scopes: [scopes.diningApi],
        account: msal.getAllAccounts()[0],
      };
      authResult = await msal.acquireTokenSilent(silentRequest);
    } catch (ex) {
      const redirectRequest: RedirectRequest = {
        scopes: [scopes.diningApi],
      };

      await msal.loginRedirect(redirectRequest);
    }

    const initParam = init || {};
    if (authResult) {
      initParam.headers = {
        ...initParam.headers,
        Authorization: "Bearer " + authResult.accessToken,
        "Dwp-Apim-Subscription-Key": config.apimSubscriptionKey,
        "X-Correlation-Id": authResult.correlationId,
      };
      appInsights.trackEvent(
        { name: url.toString() },
        {
          userId: authResult.account?.username,
          correlationId: authResult.correlationId,
          requestContent: init?.body ? init.body : "",
        },
      );
    }
    return fetch(url, initParam);
  },
});

export default diningClient;
